module.exports = __webpack_public_path__ + "static/img/picture3.1d49d2ef.png";